import React from 'react';

const DietPlan = ({ calorieRange }) => {
  const getDietPlan = () => {
    if (calorieRange >= 500 && calorieRange < 1000) {
      return (
        <div>
          <p>Suggested Vegetarian Diet Plan for 500-1000 Calories:</p>
          <p>
            - Breakfast: Fruit salad with a sprinkle of chia seeds <br />
            - Snack: Handful of almonds <br />
            - Lunch: Chickpea salad with mixed vegetables <br />
            - Snack: Greek yogurt with honey <br />
            - Dinner: Quinoa and vegetable stir-fry
          </p>
        </div>
      );
    } else if (calorieRange >= 1000 && calorieRange < 1500) {
      return (
        <div>
          <p>Suggested Vegetarian Diet Plan for 1000-1500 Calories:</p>
          <p>
            - Breakfast: Oatmeal with sliced bananas and walnuts <br />
            - Snack: Mixed berry smoothie with spinach <br />
            - Lunch: Lentil soup with whole grain bread <br />
            - Snack: Cottage cheese with pineapple chunks <br />
            - Dinner: Grilled vegetables with brown rice
          </p>
        </div>
      );
    } else if (calorieRange >= 1500 && calorieRange < 2000) {
      return (
        <div>
          <p>Suggested Vegetarian Diet Plan for 1500-2000 Calories:</p>
          <p>
            - Breakfast: Whole wheat toast with avocado and tomato <br />
            - Snack: Fresh fruit salad <br />
            - Lunch: Quinoa and black bean salad <br />
            - Snack: Hummus with carrot sticks <br />
            - Dinner: Stir-fried tofu with broccoli and brown rice
          </p>
        </div>
      );
    } else if (calorieRange >= 2000 && calorieRange < 2500) {
      return (
        <div>
          <p>Suggested Vegetarian Diet Plan for 2000-2500 Calories:</p>
          <p>
            - Breakfast: Greek yogurt with granola and berries <br />
            - Snack: Almond and raisin mix <br />
            - Lunch: Chickpea curry with basmati rice <br />
            - Snack: Banana with peanut butter <br />
            - Dinner: Spinach and paneer curry with whole wheat roti
          </p>
        </div>
      );
    } else if (calorieRange >= 2500 && calorieRange < 3000) {
      return (
        <div>
          <p>Suggested Vegetarian Diet Plan for 2500-3000 Calories:</p>
          <p>
            - Breakfast: Protein smoothie with berries and spinach <br />
            - Snack: Cottage cheese with mango slices <br />
            - Lunch: Quinoa and vegetable stir-fry <br />
            - Snack: Walnuts and dried apricots <br />
            - Dinner: Baked falafel with hummus and couscous
          </p>
        </div>
      );
    } else if (calorieRange >= 3000 && calorieRange < 3500) {
      return (
        <div>
          <p>Suggested Vegetarian Diet Plan for 3000-3500 Calories:</p>
          <p>
            - Breakfast: Vegetable omelet with whole grain toast <br />
            - Snack: Greek yogurt with mixed berries <br />
            - Lunch: Chickpea and spinach curry with brown rice <br />
            - Snack: Cottage cheese with sliced strawberries <br />
            - Dinner: Grilled eggplant and tofu with quinoa
          </p>
        </div>
      );
    } else if (calorieRange >= 3500 && calorieRange < 4000) {
      return (
        <div>
          <p>Suggested Vegetarian Diet Plan for 3500-4000 Calories:</p>
          <p>
            - Breakfast: Spinach and feta omelet with whole wheat toast <br />
            - Snack: Trail mix with dried fruits and nuts <br />
            - Lunch: Lentil and vegetable stew with quinoa <br />
            - Snack: Avocado with cherry tomatoes <br />
            - Dinner: Grilled mushrooms and paneer with sweet potato
          </p>
        </div>
      );
    } else if (calorieRange >= 4000 && calorieRange < 4500) {
      return (
        <div>
          <p>Suggested Vegetarian Diet Plan for 4000-4500 Calories:</p>
          <p>
            - Breakfast: Avocado and hummus toast with poached eggs <br />
            - Snack: Protein shake with banana <br />
            - Lunch: Quinoa bowl with mixed vegetables and tofu <br />
            - Snack: Greek yogurt with mango chunks <br />
            - Dinner: Baked sweet potato with black bean salsa
          </p>
        </div>
      );
    } else if (calorieRange >= 4500 && calorieRange <= 5000) {
      return (
        <div>
          <p>Suggested Vegetarian Diet Plan for 4500-5000 Calories:</p>
          <p>
            - Breakfast: Whole grain pancakes with berries and almond butter <br />
            - Snack: Trail mix with mixed nuts and dried fruits <br />
            - Lunch: Chickpea and vegetable curry with brown rice <br />
            - Snack: Avocado with cucumber slices <br />
            - Dinner: Lentil and quinoa stuffed bell peppers
          </p>
        </div>
      );
    } else {
      return <p>No diet plan available for this calorie range</p>;
    }
  };

  return <div className="result-container">{getDietPlan()}</div>;
};

export default DietPlan;